import { Grid, Paper } from '@mui/material';
import dayjs from 'dayjs';

import { useEffect } from 'react';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { auditLogApiKeyStore } from '../../../api/masters/audit-log-api-key-store';
import { officeApiKeyStore } from '../../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { SelectConfig, SelectResult } from '../../../components/select/select-chain.component';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SiTrackPage } from '../../../components/si-track-page';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { useSaveData } from '../../../hooks/useSaveData';

import AuditLogFilters from './audit-log-filters';
import { columns } from './grid-columns';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
};

const AuditLogPage = () => {
  const today = dayjs().format('YYYY-MM-DD');
  const lastWeek = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  const form = useReactHookForm({
    defaultValues: {
      office: { officeID: '', officeName: '' },
      project: { projectID: '', projectName: '' },
      unit: { unitID: '', unitName: '' },
      fromDate: lastWeek,
      toDate: today,
    },
  });

  const {
    isLoading: isGenerating,
    data,
    mutateAsync,
  } = useSaveData<any>(auditLogApiKeyStore.generateAuditLogWithPagination());

  const handleSubmit = async (filtersData: any) => {
    const filterDataValue = {
      pageNumber: 1,
      pageSize: 100000,
      sortExp: 'string',
      sortDir: 'string',
      startDate: dayjs(filtersData?.fromDate).format('YYYY-MM-DD'),
      endDate: dayjs(filtersData?.toDate).format('YYYY-MM-DD'),
      projectID: Number(filtersData?.project?.projectID),
      officeID: Number(filtersData?.office?.officeID),
      customerID: Number(filtersData?.customer?.customerID),
      unitID: Number(filtersData?.unit?.unitID),
      workOrderID: 0,
    };
    await mutateAsync({ data: filterDataValue });
  };

  return (
    <SiTrackPage title="Audit Log">
      <ReactHookForm formName="AUDIT_LOG_FORM" onSubmit={handleSubmit} formContextProps={form}>
        <Grid container spacing={1}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <AuditLogFilters />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Paper elevation={0} style={styling.paperStyle}>
              <SiTrackGrid
                fileTitle='audit_log'
                columns={columns}
                dataItemKey="auditLogId"
                dataItems={data?.data}
                isBusy={isGenerating}
                currentPageSize={50}
                actionPermissions={{
                  export: UserPermissionName.DOWNLOAD_GRID,
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </ReactHookForm>
    </SiTrackPage>
  );
};

export default AuditLogPage;
